<template>
  <b-container class="contact">
    <h1 class="titre">Contactez-nous !</h1>
    <p class="accroche">
      Nos conseillers sont à votre écoute du lundi au vendredi de 9h à 12h et de 14h à 19h au
      <a class="telephone" href="tel:0387390812">03 87 39 08 12</a>.
    </p>
  </b-container>
</template>

<script>
  export default {
    name: 'Contact'
  }
</script>

<style lang="scss">
@import "src/sass/app";

.contact {
  margin-top: 3rem;
  .titre {
    text-align: center;
    font-family: $titlefont;
    color: $secondcolor;
    font-size: 50px;
    font-weight: bold;
  }
  .accroche {
    margin: 2rem 0;
    font-size: 25px;
    text-align: justify;
    color: $annexecolor;
    font-family: $textfont;
    .telephone {
      text-decoration: none;
      color: $annexecolor;
    }
    .telephone:hover {
      color: $secondcolor;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue